/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Subscription_Rights_Load_ErrorInputs */

const fr_admin_subscription_rights_load_error = /** @type {(inputs: Admin_Subscription_Rights_Load_ErrorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impossible de charger la formule`)
};

/**

* @param {Admin_Subscription_Rights_Load_ErrorInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const admin_subscription_rights_load_error = /** @type {((inputs?: Admin_Subscription_Rights_Load_ErrorInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Subscription_Rights_Load_ErrorInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_admin_subscription_rights_load_error(inputs)
});